import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

export default function initScrollSlide() {
  gsap.registerPlugin(ScrollTrigger)

  const init = () => {
    ScrollTrigger.clearMatchMedia() // Czyści cache matchMedia
    ScrollTrigger.getAll().forEach((st) => st.kill(true)) // kill(true) przywraca pierwotny stan

    // 2. USUNIĘCIE PIN-SPACERA (jeśli został)
    const triggerContainer = document.querySelector('.gsap-container')
    if (
      triggerContainer &&
      triggerContainer.parentElement.classList.contains('pin-spacer')
    ) {
      const spacer = triggerContainer.parentElement
      spacer.parentNode.insertBefore(triggerContainer, spacer)
      spacer.parentNode.removeChild(spacer)
    }

    // 3. CAŁKOWITY RESET STYLÓW
    // Dodajemy 'all: unset' na chwilę, by upewnić się, że nic nie siedzi w pamięci
    gsap.set(
      [
        '.gsap-container',
        '.scroll-slides',
        '.box-list-active-zones',
        '.scroll-line'
      ],
      {
        clearProps: 'all'
      }
    )

    // Usuwamy klasy wysokościowe, by naliczyć je od nowa
    triggerContainer.classList.remove(
      'small-height',
      'height',
      'mobail-small-height'
    )

    // 4. ODŚWIEŻENIE
    ScrollTrigger.refresh()

    const slides = Array.from(document.querySelectorAll('.scroll-slides'))
    const listItems = Array.from(
      document.querySelectorAll('.cards-container ul li')
    )
    const activeZonesList = document.querySelector('.box-list-active-zones')
    const zonesWrapper = document.querySelector('.box-zones')
    const scrollLine = document.querySelector('.scroll-line')

    if (!triggerContainer || !slides.length || !listItems.length) return

    const isWidth = window.innerWidth >= 1024
    const isHeight = window.innerHeight >= 760
    const isSmallHeight = window.innerHeight < 660

    if (isSmallHeight && isWidth) {
      triggerContainer.classList.add('small-height')
    }
    if (isHeight && isWidth) {
      triggerContainer.classList.add('height')
    }

    if (!isWidth && window.innerHeight <= 840) {
      triggerContainer.classList.add('mobail-small-height')
    }

    if (scrollLine && activeZonesList) {
      scrollLine.style.height = `${activeZonesList.offsetHeight}px`
    }

    const numSlides = slides.length
    let activeIndex = 0
    const slideTimelines = new Map()

    let scrollDistance = 0
    if (activeZonesList && zonesWrapper) {
      scrollDistance = activeZonesList.offsetHeight - zonesWrapper.offsetHeight
    }

    function createTimelines() {
      slides.forEach((slide, i) => {
        const tl = gsap.timeline({ paused: true })
        gsap.set(slide, { autoAlpha: 0, y: 20 })
        tl.to(slide, {
          autoAlpha: 1,
          y: 0,
          duration: 0.5,
          ease: 'power2.out'
        })
        slideTimelines.set(slide, tl)

        if (i === 0) {
          slide.classList.add('active')
          tl.play()
        } else {
          slide.classList.remove('active')
        }
      })
      updateListItems(0)
    }

    function updateListItems(current) {
      listItems.forEach((item, index) => {
        item.classList.remove('active', 'prev')
        if (index < current) {
          item.classList.add('prev')
        } else if (index === current) {
          item.classList.add('active')
        }
      })
    }

    function switchSlide(nextIndex) {
      if (nextIndex === activeIndex) return
      const leavingSlide = slides[activeIndex]
      const enteringSlide = slides[nextIndex]
      const leavingTL = slideTimelines.get(leavingSlide)
      const enteringTL = slideTimelines.get(enteringSlide)

      if (leavingSlide) leavingSlide.classList.remove('active')
      if (leavingTL) leavingTL.reverse().timeScale(2)

      if (enteringSlide) enteringSlide.classList.add('active')
      if (enteringTL) enteringTL.restart().timeScale(1)

      updateListItems(nextIndex)
      activeIndex = nextIndex
    }

    createTimelines()

    const syncUI = (progress) => {
      if (activeZonesList && zonesWrapper) {
        const pinkLineHeight =
          window.innerHeight *
          (!isWidth && window.innerHeight <= 840 ? 0.45 : 0.27)
        const totalMoveDist = scrollDistance + pinkLineHeight
        const currentMove = -totalMoveDist * progress

        gsap.set(activeZonesList, { y: currentMove, force3D: true })

        if (scrollLine) {
          gsap.set(scrollLine, { y: currentMove, force3D: true })
        }

        const triggerPoint = pinkLineHeight
        let targetIndex = 0
        const activeZones = Array.from(
          activeZonesList.querySelectorAll('.active-zone')
        )

        activeZones.forEach((zone, index) => {
          const zoneTop = zone.offsetTop
          if (zoneTop + currentMove <= triggerPoint) {
            targetIndex = index
            zone.classList.add('active')
          } else {
            zone.classList.remove('active')
          }
        })

        if (targetIndex !== activeIndex) {
          switchSlide(targetIndex)
        }
      }
    }

    const totalScrollPath = () => {
      const pinkLineHeight =
        window.innerHeight *
        (!isWidth && window.innerHeight <= 840 ? 0.45 : 0.27)
      return scrollDistance + pinkLineHeight
    }

    ScrollTrigger.matchMedia({
      '(max-width: 1023px)': function () {
        ScrollTrigger.create({
          trigger: triggerContainer,
          start:
            !isWidth && window.innerHeight <= 840 ? 'top -103px' : 'top +50px',
          end: () => `+=${totalScrollPath()}`,
          pin: true,
          scrub: true,
          anticipatePin: 1,
          onUpdate: (self) => syncUI(self.progress)
        })
      },

      '(min-width: 1024px)': function () {
        ScrollTrigger.create({
          trigger: triggerContainer,
          start: isSmallHeight ? 'top -143px' : 'top +60px',
          end: () => `+=${totalScrollPath()}`,
          pin: true,
          scrub: true,
          anticipatePin: 1,
          onUpdate: (self) => syncUI(self.progress)
        })
      }
    })
  }

  if (document.readyState === 'complete') init()
  else window.addEventListener('load', init)
}
